import { ProjectItemWidgetSchema } from './validations/project-item-validation-schema'

const Permission = 'write:Projects'
const MetaDataFields = ['metaData.costDriversOptimizers', 'metaData.projectTeam', 'metaData.shoots']

const AddIconItemNames = ['files', 'metaData.projectTeam', 'metaData.shoots', 'projectAssets']

export { AddIconItemNames, MetaDataFields, Permission, ProjectItemWidgetSchema }
